/* eslint-disable import/no-cycle */
import { all } from 'redux-saga/effects';

import authSagas from './auth/auth.saga';
import fileSagas from './file/file.saga';
import notificationSaga from './notification/notification.saga';
import searchSagas from './search/search.saga';
import userSagas from './user/user.saga';

export default function* rootSaga(): Generator {
  yield all([authSagas(), userSagas(), fileSagas(), notificationSaga(), searchSagas()]);
}
